import { Spin } from 'antd'
import React, { Component } from 'react'
import { logo_hcm_terbaru } from "../Entryfile/imagepath.jsx";

export default class LoadingScreen extends Component {
  render() {
    return (
      <div className='text-center'>
        {/* <img src={logo_hcm_terbaru} alt="One HCM" className='fallback-logo' width={150} /> */}
        <div className='loading-screen'>
          <Spin spinning={true} size="large" style={{ fontSize: '50px' }}></Spin>
          {/* <span style={{ fontSize: '50px' }}>Loading...</span> */}
        </div>
      </div>
    )
  }
}
